import MDB from '../marketingdb';


// const growl = (text, opts) => MDB.Notify.growl(text, opts);
const success = (text, opts) => MDB.Notify.successGrowl(formatText(text), opts);
const error = (text, opts) => MDB.Notify.errorGrowl(formatText(text), opts);
const warning = (text, opts) => MDB.Notify.warningGrowl(formatText(text), opts);
const alert = (text, opts) => MDB.Notify.alertGrowl(formatText(text), opts);
const notification = (text, opts) => MDB.Notify.notificationGrowl(formatText(text), opts);
const information = (text, opts) => MDB.Notify.informationGrowl(formatText(text), opts);
const bootstrapSuccess = (text, opts) => MDB.Notify.bootstrapSuccess(formatText(text), opts);
const bootstrapInfo = (text, opts) => MDB.Notify.bootstrapInfo(formatText(text), opts);
const bootstrapWarning = (text, opts) => MDB.Notify.bootstrapWarning(formatText(text), opts);
const bootstrapDanger = (text, opts) => MDB.Notify.bootstrapDanger(formatText(text), opts);

const formatText = (text) => {
    if(!text){
        return text;
    }
    
    if(Array.isArray(text)){
        return text.join('\n');
    }
    
    return text;
};

export {
    success as successGrowl,
    error as errorGrowl,
    warning as warningGrowl,
    alert as alertGrowl,
    notification as notificationGrowl,
    information as informationGrowl,
    bootstrapSuccess as bootstrapSuccessGrowl,
    bootstrapInfo as bootstrapInfoGrowl,
    bootstrapWarning as bootstrapWarningGrowl,
    bootstrapDanger as bootstrapDangerGrowl
};

export default {
    success,
    error,
    warning,
    alert,
    notification,
    information,
    bootstrapSuccess,
    bootstrapInfo,
    bootstrapWarning,
    bootstrapDanger
};